export * from './property-color.component';
